import React from 'react';
import InputGroup from '../../InputGroup';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

const FullNameInput = props => (
    <Field
        name="fullName"
        component={InputGroup}
        type="text"
        label="Full Name"
        placeholder="Full Name"
        autocomplete="cc-name"
        maxLength={100}
        autoFocus={props.autoFocus}
    />
);

FullNameInput.propTypes = {
    autoFocus: PropTypes.bool
};

export default FullNameInput;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/FullNameInput.jsx